import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Image from "next/image";
import Link from "next/link";
import { toAssetImages } from "src/lib/utils";
import SalifyFallback from "../../salify-fallback/default";
import LazyImage from "../../salify-next-layout/default/components/LazyImage";
import { FlexBox } from "../../salify-next-layout/default/components/flex-box";
import React from "react";
import { Brand } from "src/lib/fetcher/client";

interface IProps {
  brand: Brand | undefined;
}

const BrandSection: React.FC<IProps> = ({ brand }) => (
  <>
    <SalifyFallback.Label path="Brand" default="Thương hiệu" />
    {brand?.imgUrl ? (
      <LazyImage
        src={toAssetImages(brand?.imgUrl)}
        alt={brand?.name ?? ""}
        width={876}
        height={318}
        sx={{ mt: 1.5 }}
      />
    ) : null}
    <Typography fontSize={12} mt={1.5}>
      {brand?.description}
    </Typography>
    {/* <Box sx={{ color: "primary.main", fontSize: 12, mt: "10px" }}>
      <Link href={brand?.link ?? ""}>
        <SalifyFallback.Label path="View Brand Details" default="Xem chi tiết" />
      </Link>
    </Box>
    {brand?.guidelines?.length && (
      <>
        <Divider sx={{ mx: "-20px", mb: 1, mt: "20px" }} />
        {brand?.guidelines.map((guideline, idx) => (
          <FlexBox key={guideline.text} flexDirection="row" alignItems="center" mt={1.5}>
            <Image
              src={toAssetImages(guideline.icon)}
              alt={`brand-guideline-${idx}`}
              width={24}
              height={24}
            />
            <Typography fontSize={12} ml="6px">
              {guideline.text}
            </Typography>
          </FlexBox>
        ))}
      </>
    )} */}
  </>
);
export default BrandSection;
